"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBoxToggleChip = ListBoxToggleChip;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("../../components");
const Css_1 = require("../../Css");
/** Chip used to display selections within ListBox when using the MultiSelectField */
function ListBoxToggleChip(props) {
    const { state, option, getOptionLabel, getOptionValue, disabled = false } = props;
    return ((0, jsx_runtime_1.jsx)("li", { css: Css_1.Css.mr1.mb1.$, children: (0, jsx_runtime_1.jsx)(components_1.ToggleChip, { text: getOptionLabel(option), onClick: () => {
                state.selectionManager.toggleSelection(String(getOptionValue(option)));
            }, disabled: disabled }) }));
}
